module.exports = __webpack_public_path__ + "img/erweima_kf.7164f273.png";